export const blobResponseHandler = (response: Response) => {
  return response.blob();
};
